import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { UnitOfMeasurementFormDialog } from "../unit-of-measurement-form-dialog";

import { Button } from "@mui/material";

export const AddUnitOfMeasurementFormDialog = ({
  isOpen,
  onClose,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({ name, status }) => {
    try {
      await apiClient.post("unit-of-measurements", {
        name,
        status,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan satuan ukuran"));

      throw error;
    }
  };

  return (
    <UnitOfMeasurementFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Tambah Satuan Ukuran"
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddUnitOfMeasurementFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
